import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StudentsComponent } from './layouts/students/students.component';

import { ApiModule } from './api/api.module';
import { SiteLayoutsComponent } from './layouts/site-layouts/site-layouts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './pages/site/login/login.component';
import { RegisterComponent } from './pages/site/register/register.component';
import { AdminLayoutsComponent } from './layouts/admin-layouts/admin-layouts.component';
import { AuthService } from './api/Services/auth.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './system/jwt.interceptor';
import { InstructorLayoutsComponent } from './layouts/instructor-layouts/instructor-layouts.component';




@NgModule({
  declarations: [
    AppComponent,

    SiteLayoutsComponent,
    InstructorLayoutsComponent,
    AdminLayoutsComponent,

    StudentsComponent,

    LoginComponent,
    RegisterComponent


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ApiModule,
    FormsModule,
    ReactiveFormsModule


  ],
  providers: [
    AuthService,
    [{provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true}]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
